"use client";

import React from "react";
import { Loader, Mail, CircleCheck } from "lucide-react";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage, FormDescription } from "@/components/ui/form";
function NewsletterFormContent() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="flex items-center gap-3 p-4 bg-primary/5 border border-primary/20 rounded-lg text-primary">
        <CircleCheck className="size-5 shrink-0" />
        <p className="text-sm font-medium">{successMessage}</p>
      </div>;
  }
  return <Form onSubmit={handleSubmit} className="space-y-4 w-full">
      <div className="flex flex-col md:flex-row gap-4 items-start">
        <div className="flex-1 w-full">
          <FormField control={control} name="first_name" render={({
          field
        }) => <FormItem>
                <FormLabel className="sr-only">First Name</FormLabel>
                <FormControl>
                  <Input placeholder="First Name (Optional)" {...field} className="bg-background" />
                </FormControl>
                <FormMessage />
              </FormItem>} />
        </div>

        <div className="flex-1 w-full">
          <FormField control={control} name="email" rules={{
          required: "Email is required",
          pattern: {
            value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
            message: "Please enter a valid email address"
          }
        }} render={({
          field
        }) => <FormItem>
                <FormLabel className="sr-only">Email Address</FormLabel>
                <FormControl>
                  <div className="relative">
                    <Mail className="absolute left-3 top-1/2 -translate-y-1/2 size-4 text-muted-foreground" />
                    <Input type="email" placeholder="you@example.com" className="pl-9 bg-background" {...field} />
                  </div>
                </FormControl>
                <FormMessage />
              </FormItem>} />
        </div>

        <Button type="submit" disabled={isSubmitting} className="w-full md:w-auto shrink-0">
          {isSubmitting ? <>
              <Loader className="animate-spin mr-2 size-4" />
              Subscribing...
            </> : "Subscribe"}
        </Button>
      </div>

      <FormField control={control} name="consent" rules={{
      required: "You must agree to receive updates."
    }} render={({
      field
    }) => <FormItem className="flex flex-row items-start space-x-3 space-y-0 rounded-md p-2">
            <FormControl>
              <input type="checkbox" className="mt-1 size-4 shrink-0 rounded-sm border border-primary ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 accent-primary" checked={!!field.value} onChange={field.onChange} onBlur={field.onBlur} name={field.name} ref={field.ref} />
            </FormControl>
            <div className="space-y-1 leading-none">
              <FormLabel className="text-sm font-normal text-muted-foreground cursor-pointer">
                I agree to receive AOTO's newsletter and related updates.
              </FormLabel>
              <FormDescription className="text-xs">
                You can unsubscribe at any time.
              </FormDescription>
              <FormMessage />
            </div>
          </FormItem>} />

      {submitError && <div className="p-3 bg-destructive/10 border border-destructive/20 rounded-md">
          <p className="text-sm text-destructive">{submitError}</p>
        </div>}
    </Form>;
}
export default function NewsletterSubscription() {
  return <section id="newsletter-subscription" className="w-full bg-[hsl(210,40%,96%)] dark:bg-muted/50 py-12 border-y border-border/50">
      <div className="container mx-auto px-4 md:px-6 max-w-6xl">
        <div className="flex flex-col lg:flex-row items-start lg:items-center gap-8 lg:gap-12">
          <div className="lg:w-1/3 space-y-2">
            <h2 className="text-2xl md:text-3xl font-serif font-medium text-foreground tracking-tight">
              Stay informed on Cultural Tourism trends
            </h2>
            <p className="text-muted-foreground text-sm">
              Join our newsletter for the latest insights, project updates, and industry analysis from AOTO.
            </p>
          </div>

          <div className="lg:w-2/3 w-full">
            <FormProvider formId="newsletter_subscription_insights" sectionName="Newsletter Subscription" defaultValues={{
            email: "",
            first_name: "",
            consent: false
          }} validationRules={{
            email: {
              required: true,
              pattern: "email"
            },
            consent: {
              required: true
            }
          }} submitText="Subscribe" successMessage="Thank you for subscribing! We'll send the latest insights to your inbox.">
              <NewsletterFormContent />
            </FormProvider>
          </div>
        </div>
      </div>
    </section>;
}